import { render, staticRenderFns } from "./BabysitterWrapper.vue?vue&type=template&id=63acc430&"
import script from "./BabysitterWrapper.vue?vue&type=script&lang=ts&"
export * from "./BabysitterWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports